import {Route} from '@angular/router';
import {canActivateLoggedInChild} from '@indosuara/auth';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';

export const appRoutes: Route[] = [
  {
    path: '', redirectTo: '/driver-schedule', pathMatch: 'full',
  },
  {
    path: 'home', redirectTo: '/driver-schedule', pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then(
          (m) => m.LoginComponent,
      ),
  },
  {
    path: 'login/:redirectUrl',
    loadComponent: () =>
      import('./login/login.component').then(
          (m) => m.LoginComponent,
      ),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then(
          (m) => m.HomeComponent,
      ),
    canActivate: [canActivateLoggedInChild],
  },
  {
    path: 'driver-schedule',
    loadChildren: () =>
      import('@indosuara/indopos-staff').
          then((m) => m.IndoposDriverScheduleModule),
    canActivate: [canActivateLoggedInChild],
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('@indosuara/auth-ui').then(
          (m) => m.LogoutComponent,
      ),
    canActivate: [canActivateLoggedInChild],
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('@indosuara/auth-ui').then((m) => m.ChangePasswordComponent),
    canActivate: [canActivateLoggedInChild],
  },
  {
    path: '**', component: PageNotFoundComponent,
    canActivate: [canActivateLoggedInChild],
  },
];
